import s from './ProductHero.module.scss';
import { useEffect } from 'react';
import ImageSlider from './ImageSlider/ImageSlider';
import TitleBlock from './TitleBlock/TitleBlock';
import ContentBlock from './ContentBlock/ContentBlock';
import QuantityCards from './QuantityCards/QuantityCards';
import CtaSection from './CtaSection/CtaSection';
import Benefits from 'components/Hero/Benefits';
import { ProductFAQ } from './ProductFAQ/ProductFAQ';
import { usewpdataSelectors } from 'lib/wpdataState/selectors';
import { useInView } from 'react-intersection-observer';
import { useCartActions } from 'lib/cartState/actions';

const ProductHero = () => {
  const { hero } = usewpdataSelectors();
  const { heroVisibleAction } = useCartActions();
  const { ref: heroRef, inView: isHeroVisible } = useInView({
    threshold: 0.01,
  });

  useEffect(() => {
    heroVisibleAction();
  }, [isHeroVisible]);

  return (
    <div ref={heroRef} className={s.container} style={{ background: hero.styles.background }}>
      <div className={s.productHero}>
        <ImageSlider arrayLength={5} version={'version-1'} />
        <TitleBlock />
        <ContentBlock />
        <QuantityCards />
        <CtaSection />
        <Benefits variant="productHero" />
        <ProductFAQ />
      </div>
    </div>
  );
};

export default ProductHero;
